import { Pipe, PipeTransform } from '@angular/core';
import DateHelper from '../helpers/date-helper';

@Pipe({
  name: 'formatDate'
})
export class FormatDate implements PipeTransform {
  transform(value: Date, or: string = '', format = 'dd/MM/yyyy'): string {
    return value == null ? or : DateHelper.formatDate(value, format);
  }
}
